import { render, staticRenderFns } from "./RadialProgressBar.vue?vue&type=template&id=059c94d7"
import script from "./RadialProgressBar.vue?vue&type=script&lang=js"
export * from "./RadialProgressBar.vue?vue&type=script&lang=js"
import style0 from "./RadialProgressBar.vue?vue&type=style&index=0&id=059c94d7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports